import type { ReactNode } from 'react'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import LiveChatWidget from '@/components/LiveChatWidget'
import WhatsAppButton from '@/components/WhatsAppButton'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
      <LiveChatWidget />
    </div>
  )
}

export default Layout
